import { darken, lighten } from '../utils/color';

const primaryColor = '#3A7636';
const primaryColorDark = '#204F1D';
const primaryColorLight = '#E5FAE3';
const secondaryColor = '#036589';
const secondaryColorDark = '#1D424F';
const secondaryColorLight = '#EDF8FC';
const accentColor = primaryColor;
const accentColorDark = primaryColorDark;
const accentColorLight = primaryColorLight;
const white = '#ffffff';
const black = '#212020';

export const theme = {
  primaryColor,
  primaryColorDark,
  primaryColorLight,
  secondaryColor,
  secondaryColorDark,
  secondaryColorLight,
  accentColor,
  accentColorDark,
  accentColorLight,
  white,
  black,
  navBg: secondaryColor,
  titleColor: secondaryColor,
  subTitleColor: secondaryColorDark,
  bgColor: secondaryColorLight,
  textBg: primaryColorLight,
  buttonBg: primaryColor,
  buttonBgHover: primaryColorDark,
  outlineColor: secondaryColorDark,
  gray: '#b2b2b2',
  grayDark: '#7c7c7c',
  grayLight: '#dddddd',
  disabledColor: '#b3b3b3',
  disabledBg: '#727272',
  disabledSelect: '#acacac',
  warningColor: 'red',
  overlayLight: 'rgba(0, 0, 0, 0.1)',
  overlayDark: 'rgba(0, 0, 0, 0.2)',
  focusShadow: 'rgba(3, 101, 137, 0.25)',

  // Stoplight
  stoplightGreen: '#4CAF50',
  stoplightYellow: '#E6B422',
  stoplightRed: '#D45B5B',

  // Font sizes
  fontSizeXs: '0.7rem',
  fontSizeSm: '0.8rem',
  fontSizeBase: '0.9rem',
  fontSizeMd: '1.1rem',
  fontSizeLg: '1.25rem',
  fontSizeXl: '1.75rem',
  fontSizeMobileTitle: '1.6rem',
  fontSizeTitle: '2.5rem',

  // Border radius
  borderRadius: '0.3rem',
  borderRadiusRound: '50%',

  // Breakpoint
  breakpointLg: '1600px',
  breakpoint1450: '1450px',
  breakpoint1200: '1200px',
  breakpointMd: '1000px',
  breakpointSm: '700px',

  // Header
  headerMaxSize: '5rem',
  headerMinSize: '4rem',
  logoMaxSize: '10rem',
  logoMinSize: '6rem',
  logoMobileMaxSize: '8rem',
  logoMobileMinSize: '6rem',
};
